import React, { useEffect, useRef, useState } from "react";
import { useCheckpoints } from "../../services/hooks";
import { AddRemove, Checkbox, Dropdown } from ".";
import { Grid } from "@mui/material";
import { DragIndicatorIcon } from "../../services/icons";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useCustomizeTripWorkflowMutation } from "../../api/vmsSlice";

const GenericWorkflowUpdate = ({ tripData, workflowData, setWorkflowData }) => {

	// const [workflowData, setWorkflowData] = useState(); //Array
    useEffect(()=>{
        if(tripData){
            setWorkflowData(tripData)
        }
    },[tripData])
 
    const ref = useRef();
	const { checkpoints, checkpointOptions, getCheckpoints, clearCheckpointData } = useCheckpoints(null);
	const onHandleCheckpointChange = (value, name, index) => {
        let _value = value;
        if (name === 'checkpoints') {
            _value = checkpoints.filter((_) => value.find((v) => v.value === _._id));
        }
        
        setWorkflowData(prevData => {
            const newData = [...prevData];
            newData[index] = {
                ...newData[index],
                [name]: _value
            };
            return newData;
        });
    };

	const addWorkflowListing = () => {
		setWorkflowData(prevData => {
			const maxOrder = prevData.reduce((max, item) => {
				const orderNum = parseInt(item.order) || 0;
				return orderNum > max ? orderNum : max;
			}, 0);
			
			return [
				...prevData,
				{
					order: (maxOrder + 1).toString(), 
					checkpoints: [],
					optional: false,
					visited: false 
				}
			];
		});
	};

	const removeWorkflowListing = (index) => {
		if (workflowData[index]?.visited) return;
		
		setWorkflowData(prevData => {
			const newData = [...prevData];
			newData.splice(index, 1);

			return newData.map((item, idx) => ({
				...item,
				order: (idx + 1).toString()
			}));
		});
	};


	 const moveCard = (dragIndex, hoverIndex) => {
        if (workflowData[dragIndex]?.visited) return;
        if (workflowData[hoverIndex]?.visited) return;
        
        setWorkflowData(prevData => {
            const newData = [...prevData];
            const draggedItem = newData[dragIndex];
            newData.splice(dragIndex, 1);
            newData.splice(hoverIndex, 0, draggedItem);
            return newData.map((item, index) => ({
                ...item,
                order: (index + 1).toString() 
            }));
        });
    };

	// console.log("UPdatedWorkflowData", workflowData)
	return (
		<DndProvider backend={HTML5Backend}>
		<div className="workflow-field-container  boder-rad-10p mt-3">
			{workflowData?.map((ele, index) => {
				const checkpointValue = ele.checkpoints?.map((ele) => ({ label: ele.displayName, value: ele._id })) || [];
				const isVisited = ele.visited;
				return (
					// <div className="workflow-fields  boder-rad-10p" key={`workflow_${index}`}>
					<DraggableItem key={index} index={index} moveCard={moveCard} isDraggable={!ele.visited}>
						<Grid container  sx={{backgroundColor: ele.visited ? 'rgb(231, 232, 233)' : 'transparent', borderRadius:'8px', cursor: ele.visited ? "not-allowed": "cursor"}}>
							<Grid item xl={2} lg={2} md={3} sm={4} xs={12} sx={{ display: "flex" }}>
								{/* <span id="three_dots_icon" ref={ref} style={{ cursor: "all-scroll", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
									<DragIndicatorIcon />
								</span> */}
								  {!isVisited && ( 
                                        <span 
                                            id="three_dots_icon" 
                                            style={{ 
                                                cursor: "move", 
                                                height: "100%", 
                                                display: "flex", 
                                                justifyContent: "center", 
                                                alignItems: "center",
                                                marginRight: "8px"
                                            }}
                                        >
                                            <DragIndicatorIcon />
                                        </span>
                                    )}
								<Dropdown
									id={"checkpoint"}
									name={"checkpoints"}
									value={checkpointValue}
									options={checkpointOptions}
									label={"Checkpoint"}
									multiple={true}
									required
									onChange={(option, key) => onHandleCheckpointChange(option, key, index)}
									disabled={isVisited}
									// error={error?.checkpoints && error?.checkpoints.length > 0 && error?.checkpoints[index] ? error?.checkpoints[index].checkpoints : ""}
								/>
							</Grid>
							<div className="Workflow-checkpoint-div">
								<Checkbox
									id={index}
									name={"optional"}
									checked={ele.optional || false}
									onChange={(e) => onHandleCheckpointChange(e.target.checked, e.target.name, index)}
									label={"Optional"}
									disabled={isVisited}
								/>
							</div>
							<Grid item xl={1} lg={1} md={1} sm={2} xs={6} sx={{ display: "flex", gap: "0.25rem", alignItems: "center" }}>
								{ele.visited?<></>:
								<AddRemove
									list={workflowData}
									filterMethod={(_) => _.checkpoints.length === 0}
									index={index}
									outerIndex={index}
									onAdd={addWorkflowListing}
									onRemove={removeWorkflowListing}
									disableRemove={isVisited || ele.checkpoints.length > 0}
								/>}
							</Grid>
						</Grid>
					</DraggableItem>
					// </div>
				);
			})}
		</div>
		</DndProvider>
	);
};

const DraggableItem = ({ index, moveCard, children, isDraggable = true }) => {
    const [{ isDragging }, drag] = useDrag({
        type: "CARD",
        item: { index },
        canDrag: isDraggable, // Disable drag based on prop
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const [{ isOver }, drop] = useDrop({
        accept: "CARD",
        canDrop: () => isDraggable, 
        hover: (item) => {
            if (item.index !== index) {
                moveCard(item.index, index);
                item.index = index;
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    });

    return (
        <div 
            ref={isDraggable ? drop : null} 
            className={isOver && isDraggable ? "drop-target" : ""}
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: isDraggable ? 'move' : 'default',
            }}
        >
            <div 
                className={`workflow-fields boder-rad-10p ${isDragging ? "dragging" : ""}`}
                ref={isDraggable ? drag : null}
            >
                {children}
            </div>
        </div>
    );
};
export default GenericWorkflowUpdate;
